// extracted by mini-css-extract-plugin
export default {"viewContainer":"ViewImage_viewContainer__8Wf49","cross":"ViewImage_cross__-Z37i","left":"ViewImage_left__4+W3w","right":"ViewImage_right__Sk3lw"};